import { ReactNode } from 'react';
import Head from 'next/head';
import { i18n } from 'next-i18next';
import Footer from '@sy/app-client/src/ssrAdapter/components/Footer';
import WrapWithProviders from '@sy/app-client/src/ssrAdapter/ssrWrapper';
import { ThemeProvider, fontFamilies } from '@sy/component-library';

import type { BlogMainCategory } from '~/services/blog/categories';
import BlogHeader from '~/scenes/Blog/scenes/components/BlogHeader';
import { BlogPageWrapper, FooterWrapper } from './BlogTemplate.styles';

const BlogTemplate = ({ activeCategory, children, user }: Props) => (
	<>
		<Head>
			<link
				rel="alternate"
				type="application/rss+xml"
				href="https://streamyard.com/blog/rssfeed.xml"
			/>
		</Head>
		<WrapWithProviders i18n={i18n} user={user} withTheme={false}>
			<ThemeProvider
				themeName="marketing"
				isGlobal
				fontFamily={fontFamilies.plusJakartaSans}
			>
				<>
					<BlogHeader activeCategory={activeCategory} />
					<BlogPageWrapper>{children}</BlogPageWrapper>
					<FooterWrapper>
						<Footer i18n={i18n} useDarkNewBrandingSurface={false} />
					</FooterWrapper>
				</>
			</ThemeProvider>
		</WrapWithProviders>
	</>
);

interface Props {
	activeCategory?: BlogMainCategory;
	children: ReactNode;
	user: { email: string | null; id: string | null };
}

export default BlogTemplate;
